<template>
  <div v-show="dialogVisible" class="search-check-tree">

    <el-input :placeholder="placeholderSearchText" style="max-width: 300px;" v-model="filterText"></el-input>
    <div class="tree-wrapper">
      <div class="ww-check-all" v-if="showCheckAll">
        <el-checkbox v-model="checkAll">全选</el-checkbox>
      </div>
      <el-tree
        class="filter-tree"
        :data="data"
        :show-checkbox="showCheckbox"
        :node-key="defaultProps.id|| 'id'"
        :default-checked-keys="defaultCheckedKeys"
        :default-expand-all="defaultExpandAll"
        :props="defaultProps"
        @node-click="nodeClick"
        :expandOnClickNode="expandOnClickNode"
        @check-change="checkChange	"
        :highlight-current="true"
        :check-on-click-node="true"
        :filter-node-method="filterNode"
        ref="tree2"
      ></el-tree>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'search-check-tree',
    props: {
      modalTitle: String,
      defaultProps: Object,
      data: Array,
      showCheckbox: {
        type: Boolean,
        default: true
      },
      defaultCheckedKeys: Array,
      showCheckAll: {
        type: Boolean,
        default: false
      },
      defaultExpandAll: {
        type: Boolean,
        default: false
      },
      expandOnClickNode: {
        type: Boolean,
        default: true
      },
      placeholderSearchText: {
        type: String,
        default: '请输入'
      },
      initCheckKey: {
        type: String | Object,
        default: null
      },
      dialogVisible: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        filterText: '',
        allKeys: [],
        checkAll: false,
        selectItem: {},
        noNeedToCheckAll: false
      }
    },
    created() {
    },
    mounted() {
      if (this.initCheckKey >= 0) {
        this.$refs['tree2'].setCurrentKey(this.initCheckKey)
      }
    },
    computed: {
      getAllKeys() {
        this.dep(this.data)
        return this.allKeys
      }
    },
    watch: {
      initCheckKey(val) {
        if (val === 0 || val) {
          this.setCurrentKey(val)
        }
      },
      checkAll(val) {
        if (val) {
          this.$refs['tree2'].setCheckedKeys(this.getAllKeys);
        } else {
          if (this.$refs.tree2.getCheckedKeys().length === this.getAllKeys.length) {
            this.$refs['tree2'].setCheckedKeys([]);
          }
        }
      },
      filterText(val) {
        this.$refs.tree2.filter(val)
      }
    },
    methods: {
      dep(treeData) {
        treeData.forEach((treeNode) => {
          const key = treeNode[this.defaultProps.id]
          const children = treeNode[this.defaultProps.children]
          if (key) {
            this.allKeys.push(key)
          }
          if (children) {
            this.dep(children)
          }
        });
      },
      getCheckedKeys() {
        return this.$refs.tree2.getCheckedKeys()
      },
      setCurrentKey(val) {
        if (this.$refs['tree2']) {
          setTimeout(() => {
            this.$refs['tree2'].setCurrentKey(val);
          }, 0)
        }
      },
      checkChange() {
        if (!this.noNeedToCheckAll) {
          this.noNeedToCheckAll = true
          this.checkAll = !!(this.$refs.tree2.getCheckedKeys().length === this.getAllKeys.length)
          this.noNeedToCheckAll = false
        }
      },
      filterNode(value, data, node) {
        //   console.log(value);
        //   console.log(2222);
        //   if (!value) return true;
        //   return data.label.indexOf(value) !== -1;
        // 如果什么都没填就直接返回
        if (!value) return true
        var searchName = this.defaultProps.searchName
          ? this.defaultProps.searchName
          : [].concat([this.defaultProps.label])
        if (searchName) {
          var len = searchName.length
          if (len > 0) {
            for (let i = 0; i < len; i++) {
              if (data[searchName[i]].indexOf(value) !== -1) {
                return true
              }
            }
          }
        }
        // 否则要去判断它是不是选中节点的子节点
        return this.checkBelongToChooseNode(value, data, node, searchName)
      },
      // 判断传入的节点是不是选中节点的子节点
      checkBelongToChooseNode(value, data, node, searchName) {
        const level = node.level
        // 如果传入的节点本身就是一级节点就不用校验了
        if (level === 1) {
          return false
        }
        // 先取当前节点的父节点
        let parentData = node.parent
        // 遍历当前节点的父节点
        let index = 0
        while (index < level - 1) {
          if (searchName && searchName.length > 0) {
            var len = searchName.length
            for (let i = 0; i < len; i++) {
              if (parentData.data[searchName[i]].indexOf(value) !== -1) {
                return true
              }
            }
          }
          // 否则的话再往上一层做匹配
          parentData = parentData.parent
          index++
        }
        // 没匹配到返回false
        return false
      },
      nodeClick(data, node) {
        if (node.level === 1) {
          const children = node.childNodes
          // 按目前数据情况，只做了点击一级展开所有二级
          children.length > 0 && children.map(child => {
            child.expanded = true
          })
        }
        this.selectItem = node
        this.$emit('node-click', this.selectItem)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .search-check-tree {
    .tree-wrapper {
      text-align: left;
      /*display: flex;*/
      margin: 10px 0;
      width: 100%;
      overflow-x: hidden;
      overflow-y: scroll;
      .ww-check-all {
        display: inline-block;
      }

    }


  }

</style>



// WEBPACK FOOTER //
// src/_app/wwka/src/views/components/search-check-tree.vue